/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type SurveyEventAnswer = typeof SurveyEventAnswer[keyof typeof SurveyEventAnswer];


export const SurveyEventAnswer = {
  Accepted: 'Accepted',
  Declined: 'Declined',
} as const;
